var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 37,
    viewBox: "0 0 65 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2130_837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5037 9.82975C63.1785 9.82975 62.9099 9.56297 62.9099 9.2241V1.70397H53.3734C53.0482 1.70397 52.7795 1.4372 52.7795 1.09832C52.7795 0.759449 53.0411 0.492676 53.3734 0.492676H63.4966C63.8218 0.492676 64.0905 0.759449 64.0905 1.09832V9.21689C64.0905 9.54855 63.8289 9.82254 63.4966 9.82254L63.5037 9.82975Z",
    className: "color6Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.593823 9.82975C0.919012 9.82975 1.18765 9.56297 1.18765 9.2241V1.70397H10.7242C11.0494 1.70397 11.318 1.4372 11.318 1.09832C11.318 0.759449 11.0564 0.492676 10.7242 0.492676H0.593823C0.268634 0.492676 0 0.759449 0 1.09832V9.21689C0 9.54855 0.261565 9.82254 0.593823 9.82254V9.82975Z",
    className: "color6Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5037 27.1772C63.1785 27.1772 62.9099 27.444 62.9099 27.7829V35.303H53.3734C53.0482 35.303 52.7795 35.5698 52.7795 35.9087C52.7795 36.2475 53.0411 36.5143 53.3734 36.5143H63.4966C63.8218 36.5143 64.0905 36.2475 64.0905 35.9087V27.7901C64.0905 27.4584 63.8289 27.1845 63.4966 27.1845L63.5037 27.1772Z",
    className: "color6Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.593823 27.1772C0.919012 27.1772 1.18765 27.444 1.18765 27.7829V35.303H10.7242C11.0494 35.303 11.318 35.5698 11.318 35.9087C11.318 36.2475 11.0564 36.5143 10.7242 36.5143H0.593823C0.268634 36.5143 0 36.2475 0 35.9087V27.7901C0 27.4584 0.261565 27.1845 0.593823 27.1845V27.1772Z",
    className: "color6Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84375 8.49609V18.4028V18.857V27.4514H9.99605V18.857V18.4028V8.49609H8.84375Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0117 8.48169V18.4028V18.857V27.4514H38.6692V18.857V18.4028V8.48169H38.0117Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0283 8.49609V18.4028V18.857V27.4514H48.4248V18.857V18.4028V8.49609H46.0283Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0066 8.38062V18.4026V18.8569V27.4513H45.0104V18.8569V18.4026V8.38062H44.0066Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8113 8.48169V18.4028V18.857V27.4514H42.5503V18.857V18.4028V8.48169H40.8113Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2559 8.48169V18.4028V18.857V27.4514H39.9133V18.857V18.4028V8.48169H39.2559Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4287 8.49609V18.4028V18.857V27.4514H49.9306V18.857V18.4028V8.49609H49.4287Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0547 8.49609V18.4028V18.857V27.4514H52.207V18.857V18.4028V8.49609H51.0547Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4126 8.49609V18.4028V18.857V27.4514H55.0771V18.857V18.4028V8.49609H54.4126Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1201 8.49609V18.4028V18.857V27.4514H11.622V18.857V18.4028V8.49609H11.1201Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1685 8.49609V18.4028V18.857V27.4514H53.8259V18.857V18.4028V8.49609H53.1685Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7048 8.49609V18.4028V18.857V27.4514H17.4966V18.857V18.4028V8.49609H16.7048Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7903 8.49609V18.4028V18.857V27.4514H20.5293V18.857V18.4028V8.49609H18.7903Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.427 8.49609V18.4028V18.857V27.4514H22.0844V18.857V18.4028V8.49609H21.427Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6257 8.49609V18.4028V18.857V27.4514H15.0222V18.857V18.4028V8.49609H12.6257Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6714 8.49609V18.4028V18.857V27.4514H23.3288V18.857V18.4028V8.49609H22.6714Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2991 8.48169V18.4028V18.857V27.4514H30.9565V18.857V18.4028V8.48169H30.2991Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6624 8.48169V18.4028V18.857V27.4514H29.4085V18.857V18.4028V8.48169H27.6624Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0427 8.38062V18.4026V18.8569V27.4513H26.0433V18.8569V18.4026V8.38062H24.0427Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5432 8.48169V18.4028V18.857V27.4514H32.2077V18.857V18.4028V8.48169H31.5432Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2329 8.49609V18.4028V18.857V31.5468H34.979V18.857V18.4028V8.49609H33.2329Z",
    className: "color1Fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8696 8.49609V18.4028V18.857V31.5468H36.5341V18.857V18.4028V8.49609H35.8696Z",
    className: "color1Fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2130_837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.0976,
    height: 36,
    className: "baseColor2Fill",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCodeIcon);
export default __webpack_public_path__ + "static/media/bar-code-icon.61024161dbcf07c1df5cf27aeb60e8da.svg";
export { ForwardRef as ReactComponent };